/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { initVerifyRechargeInfo, useAnimationTopUpStore } from "../../store";
import {
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
  Whether,
} from "project-config/constants";
import { BindActivityInfo, Detail } from "@/components/top-up/types";
import { AnimationNormalRecharge } from "../animation-normal-recharge";
import { useEffect, useState } from "react";
import { AnimationGiftCoupon } from "../animation-gift-coupon";
import { useSearchParams } from "react-router-dom";
import { findWelfareData } from "@/components/top-up/help/activityUtil";
import { RechargeInputForm } from "../charge-input-form";
import { ActivityRechargeRadioList } from "../activity-recharge-radio-list";
import { PaymentWay } from "../payment-way";
import { RechargeTips } from "../../help/tips";
import { BalanceTipType, ExtraWelfareTipType } from "../../types";
import { useTranslation } from "react-i18next";
import { CommonSecondTabsContent, CommonUpperPart } from "../../atom";
import { TopUpSecondTabs } from "@/components/top-up/components/second-tabs";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { useCountdown } from "@/pages/picture-top-up/components/picture-balance-recharge/hooks/useCountDown";
import { NewUserWelfareBar } from "@/components/new-user-welfare-bar";
import { TimesStamp } from "@/constant/TimesStamp";
import { RechargeVoucher } from "../recharge-voucher";
import { useToastStore } from "@/store/toast-store";

export function AnimationBalanceRecharge({
  activityInfo,
}: {
  activityInfo?: BindActivityInfo;
}) {
  const {
    isZh,
    isAnimationActiveOverTime,
    userInfo,
    userLevel,
    currencySymbol,
    userCumulative,
  } = useGlobalStore();
  const { t } = useTranslation("topup");
  const { userProperty } = useUserPropertyStore();
  const { days, hours, minutes, seconds } = useCountdown(
    userInfo?.registerDate ?? 0,
    TimesStamp.DAY * 5
  );
  const { setter } = useAnimationTopUpStore();
  const { showGlobalToast } = useToastStore();
  const addPayRecord = useAnimationTopUpStore((state) => state.addPayRecord);
  const amount = useAnimationTopUpStore((state) => state.amount);
  const paying = useAnimationTopUpStore((state) => state.paying);
  const HangTags = useAnimationTopUpStore((state) => state.HangTags);
  const lotteryActivityInfoList = useAnimationTopUpStore(
    (state) => state.lotteryActivityInfoList
  );
  const checkedRadioId = useAnimationTopUpStore(
    (state) => state.checkedRadioId
  );
  const luckDrawGiftActivityInfo = useAnimationTopUpStore(
    (state) => state.luckDrawGiftActivityInfo
  );
  const rechargeSecondActiveName = useAnimationTopUpStore(
    (state) => state.rechargeSecondActiveName
  );
  const [searchParams] = useSearchParams();

  const goal = activityInfo
    ? PaymentPurposeCode.ActivityRecharge
    : PaymentPurposeCode.OrdinaryRecharge;
  const [balanceTip, setBalanceTip] = useState<BalanceTipType[]>();
  const [extraTip, setExtraTip] = useState<ExtraWelfareTipType[]>();
  const verifyRechargeInfo = useAnimationTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const { couponNO, activityId, rechargeAmount } = verifyRechargeInfo;
  const verifyRechargeCode = useAnimationTopUpStore(
    (state) => state.verifyRechargeCode
  );

  const welfareData =
    activityInfo && (findWelfareData(activityInfo, Number(amount)) as Detail);
  const isShowExtraGift =
    welfareData?.detailList && welfareData.detailList.length > 1;

  const qrcodeLink = () => {
    let paramsStr = `&${QRCODE_QUERY_MAP.orderType}=${
      OrderPaymentTypeCode.OrdinaryOrder
    }&${QRCODE_QUERY_MAP.amount}=${Number(amount)}&${
      QRCODE_QUERY_MAP.rechargeGoal
    }=${goal}`;
    if (isShowExtraGift && checkedRadioId) {
      paramsStr += `&${QRCODE_QUERY_MAP.activityDetailId}=${checkedRadioId}`;
    }
    if (couponNO && Number(amount) >= rechargeAmount) {
      paramsStr += `&${QRCODE_QUERY_MAP.couponNO}=${couponNO}`;
    }
    return paramsStr;
  };

  const onClickCantScanCode = async () => {
    let params = {};
    params = {
      agent: searchParams.get("agent") || "",
      currency: userInfo?.zone,
      payMethod: PaymentTypeCode.Alipay,
      amount: Number(amount),
      rechargeGoal: goal,
      rechargeChannels: rechargeChannelsCode.Web,
    };
    if (isShowExtraGift && checkedRadioId) {
      params = { ...params, activityDetailId: checkedRadioId };
    }
    // 二次进行充值兑换判断
    if (couponNO && Number(amount) >= rechargeAmount) {
      params = {
        ...params,
        couponNo: couponNO,
        couponActivityId: activityId,
      };
      const { code } = await verifyRechargeCode({
        couponNO,
        amount: Number(amount),
      });
      if (code !== 200) {
        setter({
          verifyRechargeInfo: initVerifyRechargeInfo,
        });
        showGlobalToast({
          type: "error",
          content: t(`renderbus_coupon_code_tips_${code}`),
        });
        return;
      }
    }
    await addPayRecord(params);
  };

  const getRechargeSecondTabList = () => {
    let list = [];
    list.push(
      activityInfo
        ? {
            label: isZh
              ? luckDrawGiftActivityInfo
                ? luckDrawGiftActivityInfo.activityName
                : activityInfo.activityName
              : luckDrawGiftActivityInfo
              ? luckDrawGiftActivityInfo.activityName
              : activityInfo.activityNameEn,
            key: "second-tab-animation-activity-recharge",
            children: (
              <>
                <CommonUpperPart>
                  {/* 充值赠送券 */}
                  <AnimationGiftCoupon activityInfo={activityInfo} />
                  <RechargeInputForm />
                  {/* 额外赠送 */}
                  {isShowExtraGift && (
                    <ActivityRechargeRadioList activityInfo={activityInfo} />
                  )}
                  {/* 充值兑换券 */}
                  <RechargeVoucher />
                </CommonUpperPart>
                <PaymentWay
                  paying={paying}
                  onClickCantScanCode={() => void onClickCantScanCode()}
                  qrcodeLink={qrcodeLink()}
                  balanceTip={balanceTip}
                  extraTip={extraTip}
                />
              </>
            ),
          }
        : {
            label: luckDrawGiftActivityInfo
              ? isZh
                ? luckDrawGiftActivityInfo.activityName
                : luckDrawGiftActivityInfo.activityNameEn
              : t("topUp_balance_title"),
            key: "second-tab-animation-balance-recharge",
            children: (
              <>
                <CommonUpperPart>
                  {/* 常规余额充值 和 抽奖券 */}
                  <AnimationNormalRecharge />
                  <RechargeInputForm />
                  {/* 充值兑换券 */}
                  <RechargeVoucher />
                </CommonUpperPart>
                <PaymentWay
                  paying={paying}
                  onClickCantScanCode={() => void onClickCantScanCode()}
                  qrcodeLink={qrcodeLink()}
                  balanceTip={balanceTip}
                  extraTip={extraTip}
                />
              </>
            ),
          }
    );
    return list;
  };

  useEffect(() => {
    const rechargeTips = new RechargeTips({
      amount: Number(amount),
      userProperty,
      userLevel,
      userCumulative,
      currencySymbol,
      isAnimationActiveOverTime,
      HangTags,
      activityInfo,
      luckDrawGiftActivityInfo,
      lotteryActivityInfoList,
      checkedRadioId: checkedRadioId,
      verifyRechargeInfo,
    });
    void rechargeTips.init();
    setBalanceTip(rechargeTips.balanceTip);
    setExtraTip(rechargeTips.extraWelfareTip);
  }, [
    amount,
    userLevel,
    userCumulative,
    currencySymbol,
    isAnimationActiveOverTime,
    HangTags,
    activityInfo,
    luckDrawGiftActivityInfo,
    lotteryActivityInfoList,
    checkedRadioId,
    verifyRechargeInfo,
  ]);

  useEffect(() => {
    setter((state) => {
      state.rechargeSecondActiveName = getRechargeSecondTabList()[0].key;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {/* 限时福利 */}
      {userProperty.animationNewUserRegister === Whether.No &&
        userProperty.animationInviteCount === 0 && (
          <NewUserWelfareBar
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            tips={t("animation_new_user_welfare_tip")}
          />
        )}
      <CommonSecondTabsContent>
        <TopUpSecondTabs
          tabsList={getRechargeSecondTabList()}
          activeKey={rechargeSecondActiveName}
          onChange={(k) => {
            setter((state) => {
              state.rechargeSecondActiveName = k;
            });
          }}
        />
      </CommonSecondTabsContent>
    </div>
  );
}
